"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries Kenya M-Pesa with non-Kenyan phone
 * This is a wrapper around CountryPhonePrompt with Kenya-specific configuration
 */
export default function KenyaPhonePrompt({ 
  onClose,
  onSwitchToStripe,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const kenyaConfig = {
    title: t.kenya_phone_title,
    requiredPrefix: "+254",
    requiredCountryName: "Kenya",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={null}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={kenyaConfig}
    />
  );
}
